import { Context, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';

export const createContextStore = <StoreType>(context: Context<StoreApi<StoreType> | null>, contextName: string) => {
  return <SelectorReturnType>(selector: (state: StoreType) => SelectorReturnType): SelectorReturnType => {
    const store = useContext(context);

    if (!store) {
      throw Error(`${contextName} not provided`);
    }

    return useStore(store, selector);
  };
};
